import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cleanFAQ, DBDef_FAQ } from '@app/advisor-ui-shared';
import { createWorkHubManager } from '@app/styles';
import { ModuleFE_FAQ } from '../../../_entity/frequently-asked-question/ModuleFE_FAQ.js';
import { Renderer_FAQHeader } from './renderers/Renderer_FAQHeader/Renderer_FAQHeader.js';
import { Editor_FAQ } from '../../Editor_FAQ/Editor_FAQ.js';
import './Manager_FAQ.scss';
import { LL_V_L } from '@nu-art/thunderstorm-frontend/index';
const Editor_FAQ_Wrapper = (props) => _jsxs(LL_V_L, { className: 'manager-faq', children: [_jsx(Renderer_FAQHeader, { workHubItem: props.workHubItem, renderArgs: props.renderArgs }), _jsx(Editor_FAQ, { editable: props.editable, editMode: props.renderArgs.editMode, hideHeader: true })] });
export const Manager_FAQ = createWorkHubManager({
    module: ModuleFE_FAQ,
    dbDef: DBDef_FAQ,
    defaultItem: cleanFAQ,
    labelResolver: (item) => item.label ?? 'New FAQ',
    EditorComponent: Editor_FAQ_Wrapper,
});
//# sourceMappingURL=Manager_FAQ.js.map